<app-button
    [disabled]="disabled()"
    [htmlType]="'button'"
    [icon]="['fas', 'trash']"
    [iconSize]="'lg'"
    [tooltip]="tooltip()"
    [type]="ButtonType.ALERT_SECONDARY"
    (onClick)="delete.emit()" />
